const QuickReplyData = [
    
]

export default QuickReplyData;